import { MaturedStatusIndicator } from './MaturedStatusIndicator';

export const MaturedStatusDescriptions:Map<MaturedStatusIndicator, string> = new Map([
  [MaturedStatusIndicator.MATURED_DATE, 'Matured Date'],
  [MaturedStatusIndicator.STATUS_CODE, 'Status Code'],
  [MaturedStatusIndicator.STATUS_CODE_AND_MATURED_DATE, 'Matured Date AND Status Code'],
  [MaturedStatusIndicator.STATUS_CODE_OR_MATURED_DATE, 'Matured Date OR Status Code'],
]);

export default MaturedStatusDescriptions;
